import Image from 'next/image';

export default function Footer() {
  return (
    <footer style={{
      background: 'var(--navy-deep)',
      color: 'rgba(246, 241, 230, 0.7)',
      padding: '3.5rem 3rem 2rem',
      textAlign: 'center',
      borderTop: '1px solid rgba(201, 164, 76, 0.2)',
    }}>
      <Image src="/logo.png" alt="Queen of Angels crest" width={50} height={50} style={{
        marginBottom: '1.5rem', opacity: 0.9, height: 50, width: 'auto',
      }} />
      <p className="gaelic" style={{
        fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic',
        color: 'var(--gold)', fontSize: '1.1rem', marginBottom: '1.5rem',
        letterSpacing: '0.05em',
      }}>Sona Bliantain na nAingeal</p>
      <p style={{ fontSize: '0.85rem', marginBottom: '0.5rem' }}>Queen of Angels Primary School</p>
      <p style={{ fontSize: '0.85rem', marginBottom: '0.5rem' }}>qoais50.ie · Celebrating 50 Years · 1976 — 2026</p>
      <p className="copy" style={{
        fontSize: '0.72rem', letterSpacing: '0.2em',
        textTransform: 'uppercase', marginTop: '2rem',
        color: 'rgba(246, 241, 230, 0.4)',
      }}>© 2026 Queen of Angels · All Rights Reserved</p>
    </footer>
  );
}
